import { useState, useEffect } from "react";
import sdk from "@farcaster/miniapp-sdk";

function isMobileDevice(): boolean {
  // Check for touch capability
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Check user agent for mobile indicators
  const mobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  // Consider it mobile if it has touch AND mobile user agent
  // This prevents desktop browsers with touch screens from being flagged as mobile
  return hasTouch && mobileUserAgent;
}

export function DesktopBlocker() {
  const appUrl = "https://dasher.fit";
  const [isDesktop, setIsDesktop] = useState(false);
  const [isInFarcaster, setIsInFarcaster] = useState(false);

  useEffect(() => {
    // Only run on client side
    setIsDesktop(!isMobileDevice());

    // Check if running inside Farcaster client
    const checkFarcaster = async () => {
      try {
        const context = await sdk.context;
        if (context) {
          setIsInFarcaster(true);
        }
      } catch {
        // Not in Farcaster environment
      }
    };
    checkFarcaster();
  }, []);

  // Disable in development mode
  if (import.meta.env.DEV) return null;

  // Don't block if running inside Farcaster (mini app or developer tools)
  if (isInFarcaster) return null;

  // Don't render anything on mobile devices
  if (!isDesktop) return null;

  return (
    <div className="fixed inset-0 z-100 bg-background-light dark:bg-background-dark flex flex-col items-center justify-center p-8 text-center">
      <img
        src="/Dasher.png"
        alt="Dasher Logo"
        className="h-20 w-auto object-contain mb-6"
      />
      <h1 className="text-3xl font-bold text-content-light dark:text-white mb-3">
        Mobile Only
      </h1>
      <p className="text-lg text-content-light/70 dark:text-white/70 max-w-md mb-8">
        Dasher is designed for mobile devices. Scan the QR code below to open on your phone.
      </p>

      {/* QR Code */}
      <div className="bg-white p-4 rounded-2xl mb-6">
        <img
          src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(appUrl)}&bgcolor=ffffff&color=0d1c0d`}
          alt="Scan to open Dasher on mobile"
          className="w-[180px] h-[180px]"
        />
      </div>

      <div className="flex items-center gap-2 text-primary mb-2">
        <span className="material-symbols-outlined text-2xl">smartphone</span>
        <span className="text-base font-medium">Scan with your phone camera</span>
      </div>

      <p className="text-sm text-content-light/50 dark:text-white/50">
        or visit <span className="text-primary font-medium">dasher.fit</span> on mobile
      </p>
    </div>
  );
}
